// @todo move to date time utilities once everything is cleaned up
export const timeOfDayRegEx = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9](\s[AaPp][Mm])?$/;
// named according to https://ss64.com/dates.html
export const isTimeOfDayMatch = string => timeOfDayRegEx.test(string);
